class MenuCollapsed {
  public key = "menu_collapsed";

  public set(value: boolean): void {
    localStorage.setItem(this.key, value.toString());
  }

  public remove(): void {
    localStorage.removeItem(this.key);
  }

  public get(): boolean {
    const value = localStorage.getItem(this.key);
    return value === "true" ? true : false;
  }
}

const menuCollapsedHelper = new MenuCollapsed();

export default menuCollapsedHelper;
